'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Button2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_bee-button@1.0.6@bee-button/build/index.js
// module id = 65
// module chunks = 0